class CsrfHelper {
    constructor() { }
    static getInstance() {
        if (!CsrfHelper.instance) {
            CsrfHelper.instance = new CsrfHelper();
        }
        return CsrfHelper.instance;
    }
    get csrfToken() {
        return this.getMetaContent('_csrf');
    }
    get csrfHeader() {
        return this.getMetaContent('_csrf_header');
    }
    get csrfParameter() {
        return this.getMetaContent('_csrf_parameter') || '_csrf';
    }
    getHeaders() {
        if (!this.csrfHeader || !this.csrfToken) {
            console.warn(`⚠️ CSRF tokens not found - header: "${this.csrfHeader}", token: "${this.csrfToken}"`);
            return {};
        }
        const headers = {
            [this.csrfHeader]: this.csrfToken
        };
        console.debug(`✅ CSRF headers configured - ${this.csrfHeader}: ${this.csrfToken.substring(0, 10)}...`);
        return headers;
    }
    getMetaContent(name) {
        const meta = document.querySelector(`meta[name='${name}']`);
        return meta ? meta.getAttribute('content') || "" : "";
    }
}
const csrfInstance = CsrfHelper.getInstance();
export { csrfInstance };
